import { CalendarIcon } from "lucide-react";
import { Input } from "@/components/ui/input";

export function DatePicker({ value, onChange, testId }) {
  return (
    <div className="relative">
      <CalendarIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        type="date"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9"
        data-testid={testId}
      />
    </div>
  );
}
